<div class="card-block" id="tabletransaccion">
    <div class="card-block table-border-style">
        <div class="table-responsive table-pad-10">
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>
                            Número de Transacción
                        </th>
                        <th>
                            Número de Contrato
                        </th>
                        <th>
                            Cliente
                        </th>
                        <th>
                            Instrumento
                        </th>
                        <th>
                            Divisa
                        </th>
                        <th>
                            Tipo de Transacción
                        </th>
                        <!-- <th>

                        </th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let transaccion of this.alertaService.transaccionesRelacionar; let i = index">
                        <th scope="row">{{transaccion.referencia}}</th>
                        <td>{{transaccion.contrato}}</td>
                        <td>{{transaccion.nombre}} {{transaccion.sNombre}}
                            {{transaccion.apellidoPaterno}} {{transaccion.apellidoMaterno}}</td>
                        <td>{{transaccion.instrumento}}</td>
                        <td>{{transaccion.divisa}}</td>
                        <td>
                            {{ transaccion.tipoOperacion }}
                        </td>
                        <!-- <td class="text-center">
                            <span class="mytooltip tooltip-effect-5 ">
                                <span class="tooltip-item ">
                                    <i class="icofont icofont-document-search" data-toggle="modal"
                                        data-target="#large-Modal" (click)="verDetalle(transaccion)"></i>
                                </span>
                                <span class="tooltip-content clearfix ">
                                    <span class="tooltip-text text-center ">Ver Detalle</span>
                                </span>
                            </span>

                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row table-pad-10 ">
        <div class="col ">
            Página {{ transacciones.Pagina }} de {{numPage}} <br /> Total {{totalRegistros}}
        </div>
        <div class="col" *ngIf="totalRegistros > 15">
            <nav aria-label="Page navigation example ">
                <ul class="pagination justify-content-end ">
                    <li class="page-item ">
                        <button class="page-link btn " (click)="paginador(false) " tabindex="-1"
                            [disabled]="this.transacciones.Pagina <= 1">Regresar</button>
                    </li>
                    <li class="page-item ">
                        <button class="page-link btn " (click)="paginador(true)"
                            [disabled]="this.totalRegistros < 15 || this.transacciones.Pagina == this.numPage">Siguiente</button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</div>


<div class="modal fade" id="large-Modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Detalle de la Transacción</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <h6 class="text-left text-muted"> Cliente: {{transaccion.nombre}} {{transaccion.sNombre}}
                        {{transaccion.apellidoPaterno}} {{transaccion.apellidoMaterno}} </h6>
                    <div class="row">

                        <div class="col">
                            <div class="form-group">
                                <label>Número Transacción</label>
                                <input type="text" class="form-control" disabled name="referencia"
                                    [(ngModel)]="transaccion.referencia" />
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Perfil</label>
                                <input type="text" class="form-control" disabled name="perfil"
                                    [(ngModel)]="transaccion.perfil" />
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Contrato/Número Cuenta</label>
                                <input type="text" class="form-control" disabled name="Contrato"
                                    [(ngModel)]="transaccion.contrato" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Tipo Movimiento</label>
                                <input type="text" class="form-control" disabled name="TipoOperacion"
                                    [(ngModel)]="transaccion.tipoOperacion" />
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Fecha Operación</label>
                                <input type="text" class="form-control" disabled name="FechaPago"
                                    [(ngModel)]="transaccion.tFechaPago" />
                            </div>

                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Producto</label>
                                <input type="text" class="form-control" disabled name="Producto"
                                    [(ngModel)]="transaccion.producto" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Divisa</label>
                                <input type="text" class="form-control" disabled name="Divisa"
                                    [(ngModel)]="transaccion.divisa" />
                            </div>
                        </div>

                        <div class="col">
                            <div class="form-group">
                                <label>Importe Total</label>
                                <input type="text" class="form-control" disabled name="tMontoTotal"
                                    [(ngModel)]="transaccion.tMontoTotal" />
                            </div>
                        </div>

                        <div class="col">
                            <div class="form-group">
                                <label>Instrumento</label>
                                <input type="text" class="form-control" disabled name="Instrumento"
                                    [(ngModel)]="transaccion.instrumento" />
                            </div>
                        </div>
                    </div>
                    <h4 class="sub-title">
                        Geolocalización
                    </h4>
                    <div class="row">
                        <div class="col ">
                            <div class="form-group ">
                                <label>Latitud</label>
                                <input type="text " class="form-control " placeholder="Latitud" name="Latitud"
                                    [(ngModel)]="transaccion.latitud" [ngModelOptions]="{ standalone: true }"
                                    disabled />
                            </div>
                        </div>

                        <div class="col">
                            <label for="exampleSelect1 ">Longitud</label>
                            <input type="text " class="form-control " placeholder='Longitud' name="Longitud"
                                [(ngModel)]="transaccion.longitud" [ngModelOptions]="{ standalone: true }" disabled />
                        </div>

                    </div>
                    <div class="row">
                        <div #map id="map"
                            style="height: 250px; width: 100%; position: initial !important; margin: 1em;"></div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default waves-effect " data-dismiss="modal">
                    Regresar
                </button>
            </div>
        </div>
    </div>
</div>